import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useValueMessageDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const singular = getDisplayName('valueMessage', 'Value Message')
    const plural = pluralize(singular)

    return { singular, plural }
}

export default useValueMessageDisplayName
